// Generated by purs version 0.13.0
"use strict";
var Ritoppu_Mutation_Stats = require("../Ritoppu.Mutation.Stats/index.js");
var onStage = function (f) {
    return function (game) {
        return {
            stage: f(game.stage),
            dungeonLevel: game.dungeonLevel
        };
    };
};
var hitPlayer = function (damage) {
    return function (game) {
        return {
            stage: {
                player: {
                    pos: game.stage.player.pos,
                    stats: Ritoppu_Mutation_Stats.takeDamage(damage)(game.stage.player.stats),
                    turn: game.stage.player.turn,
                    inventory: game.stage.player.inventory,
                    level: game.stage.player.level,
                    equipment: game.stage.player.equipment
                },
                tiles: game.stage.tiles,
                size: game.stage.size,
                seen: game.stage.seen,
                items: game.stage.items,
                fovMask: game.stage.fovMask,
                creatures: game.stage.creatures
            },
            dungeonLevel: game.dungeonLevel
        };
    };
};
module.exports = {
    onStage: onStage,
    hitPlayer: hitPlayer
};
